import { useCallback, useEffect, useState } from "react";

import { api_without_cancellation } from "../../../../api/api";

const normalizeCaseType = (caseType) => ({
  id: caseType?.id ?? caseType,
  name: caseType?.name ?? "",
  icon: caseType?.icon ?? null,
});

const normalizeTemplate = (template = {}) => {
  const rawCaseTypes = template.case_types ?? template.case_type_id ?? [];

  const caseTypes = (Array.isArray(rawCaseTypes) ? rawCaseTypes : [rawCaseTypes])
    .filter((caseType) => caseType !== null && caseType !== undefined)
    .map(normalizeCaseType);
  return {
    id: template.id ?? template.template_id,
    name: template.name || template.document?.file_name || "Untitled template",
    firmId: template.firm_id ?? null,
    isGlobal: Boolean(template.is_global),
    document: {
      id: template.document?.id ?? null,
      fileName:
        template.document?.file_name ||
        template.file_name ||
        template.filename ||
        "Untitled document",
      url: template.document?.url || template.url || "",
    },
    caseTypes,
    slotId: template.slot_id ?? null,
    slotNumber: template.slot_number ?? null,
    slotName: template.slot_name || "",
    fieldsCount: template.fields_count ?? 0,
    createdAt: template.created_at || "",
  };
};

const getTemplatesFromResponse = (data) => {
  const payload = data?.data ?? data;

  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.templates)) return payload.templates;
  if (Array.isArray(payload?.results)) return payload.results;

  throw new Error("Unexpected E-Signature templates response.");
};

const useGetESignatureTemplates = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTemplates = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const { data } = await api_without_cancellation.get("/sign/templates/");
      const items = getTemplatesFromResponse(data).map(normalizeTemplate);

      setTemplates(items);
      return items;
    } catch (requestError) {
      setError(requestError);
      throw requestError;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTemplates().catch(() => {});
  }, [fetchTemplates]);

  return { templates, loading, error, refetch: fetchTemplates };
};

export default useGetESignatureTemplates;
